import { render, staticRenderFns } from "./StudentBannerMobile.vue?vue&type=template&id=05273b87&scoped=true&"
import script from "./StudentBannerMobile.vue?vue&type=script&lang=js&"
export * from "./StudentBannerMobile.vue?vue&type=script&lang=js&"
import style0 from "./StudentBannerMobile.vue?vue&type=style&index=0&id=05273b87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05273b87",
  null
  
)

export default component.exports